export default [
  {
    path: "*",
    meta: {
      public: true
    },
    redirect: {
      path: "/404"
    }
  },
  {
    path: "/404",
    meta: {
      public: true
    },
    name: "NotFound",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/NotFound.vue`
      )
  },
  {
    path: "/",
    redirect: {
      path: "/product-dashboard"
    }
  },
  {
    path: "/store/:id",
    meta: {
      public: true
    },
    name: "ProductListing",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        //`@/views/ProductListing.vue`
        `@/views/Storefront/SingleStore.vue`
      )
  },
  {
    path: "/sproduct/:id",
    meta: {
      public: true
    },
    name: "SProduct",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        //`@/views/Storefront/ProductDetails.vue`
        `@/views/Storefront/SingleProduct.vue`
      )
  },
  {
    path: "/:store/search/:query",
    meta: {
      public: true
    },
    name: "Search",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        //`@/views/Storefront/ProductDetails.vue`
        `@/views/Storefront/Search.vue`
      )
  },
  {
    path: "/cart",
    meta: {
      public: true
    },
    name: "CartDetails",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        //`@/views/Storefront/CartDetails.vue`
        `@/views/Storefront/Cart.vue`
      )
  },
  {
    path: "/checkout",
    meta: {
      public: true
    },
    name: "Checkout",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        //`@/views/Storefront/Checkout.vue`
        `@/views/Storefront/CheckoutNew.vue`
      )
  },
  {
    path: "/order-complete",
    meta: {
      public: true
    },
    name: "OrderComplete",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        //`@/views/Storefront/Checkout.vue`
        `@/views/Storefront/OrderComplete.vue`
      )
  },
  {
    path: "/login",
    meta: {
      public: true
    },
    name: "Login",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Login.vue`
      )
  },
  {
    path: "/logout",
    meta: {
      public: true
    },
    name: "Logout",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Logout.vue`
      )
  },
  {
    path: "/register",
    meta: {
      public: true
    },
    name: "Register",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Register.vue`
      )
  },
  {
    path: "/onboarding",
    meta: {
      public: true,
      loggedin: true
    },
    name: "Onboarding",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Onboarding.vue`
      )
  },
  {
    path: "/privacy-policy",
    meta: {
      public: true
    },
    name: "privacyPolicy",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/privacyPolicy.vue`
      )
  },
  {
    path: "/business-details",
    meta: {
      public: true,
      loggedin: true
    },
    name: "RegisterNext",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/RegisterNext.vue`
      )
  },
  {
    path: "/verify-account",
    meta: {
      public: true,
      //loggedin: true
    },
    name: "VerifyAccount",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/VerifyAccount.vue`
      )
  },

  /*{
    path: "/more-details",
    name: "RegisterNext",
    component: () =>
      import(
        // webpackChunkName: "routes" 
        `@/views/RegisterNext.vue`
      )
  },*/
  {
    path: "/product-dashboard",
    meta: {
      breadcrumb: true
    },
    name: "ProductDashboard",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/ProductDashboard.vue`
      )
  },
  {
    path: "/add-product",
    meta: {
      breadcrumb: true
    },
    name: "AddProduct",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Product/AddProduct.vue`
      )
  },
  {
    path: "/add-product-onboarding",
    meta: {
      breadcrumb: true
    },
    name: "AddProductOnboarding",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/components/Products/AddProductOnboarding.vue`
      )
  },
  {
    path: "/profile",
    meta: {
      breadcrumb: true
    },
    name: "Profile",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Product/Profile.vue`
      )
  },
  {
    path: "/choose-del",
    meta: {
      breadcrumb: true
    },
    name: "chooseDelivery",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/components/Delivery/ChooseDelivery.vue`
      )
  },
  {
    path: "/auto-del",
    meta: {
      breadcrumb: true
    },
    name: "AutoDelivery",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/components/Delivery/AutoDelivery.vue`
      )
  },
  {
    path: "/manual-delivery",
    meta: {
      breadcrumb: true
    },
    name: "ManualDelivery",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/components/Delivery/ManualDelivery.vue`
      )
  },
  {
    path: "/product-list",
    meta: {
      breadcrumb: true
    },
    name: "ProductList",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Product/ProductList.vue`
      )
  },
  {
    path: "/all-products",
    meta: {
      breadcrumb: true
    },
    name: "AllProducts",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        //`@/components/Products/AllProducts.vue`
        `@/views/Product/ProductList.vue`
      )
  },
  {
    path: "/product-edit/:id",
    meta: {
      breadcrumb: true
    },
    name: "ProductEdit",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/components/Products/ProductEdit.vue`
      )
  },
  {
    path: "/orders",
    meta: {
      breadcrumb: true
    },
    name: "Orders",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/components/Orders/Orders.vue`
      )
  },
  {
    path: "/order-insights",
    meta: {
      breadcrumb: true
    },
    name: "Insight",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/components/Orders/OrderInsight.vue`
      )
  },
  {
    path: "/settings",
    meta: {
      breadcrumb: true
    },
    name: "Settings",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/components/Settings/Settings.vue`
      )
  },
  {
    path: "/user-settings",
    meta: {
      breadcrumb: true
    },
    name: "UserSetting",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/components/Settings/UserSetting.vue`
      )
  },
  {
    path: "/reset-password",
    meta: {
      public: true
    },
    name: "ResetPassword",
    component: () =>
      import(
        // webpackChunkName: "routes" 
        `@/components/Settings/Password.vue`
      )
  }
];
